import { render, staticRenderFns } from "./testingCheckbox.vue?vue&type=template&id=da06cf5a&"
import script from "./testingCheckbox.vue?vue&type=script&lang=js&"
export * from "./testingCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports